var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "height": "auto",
      "width": "60%",
      "scrollable": true,
      "name": "operation-info",
      "classes": "modal_default",
      "clickToClose": true,
      "data-testid": "visit-operation-info"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.operation.code) + " - " + _vm._s(_vm.operation.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row m-0"
  }, [_c('div', {
    staticClass: "col-sm-3 p-0"
  }, [_c('h4', [_vm._v(_vm._s(_vm.operation.point_total) + " bodů")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 p-0"
  }, [_c('h4', [_vm._v(_vm._s(_vm.operation.duration) + " minut")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("popis")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.description !== "" ? _vm.operation.description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("čím výkon začíná")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.start_description !== "" ? _vm.operation.start_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("obsah a rozsah výkonu")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.scope_description !== "" ? _vm.operation.scope_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("čím výkon končí")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.end_description !== "" ? _vm.operation.end_description : '-'))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "card-title"
  }, [_vm._v("podmínky")]), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.operation.condition_description !== "" ? _vm.operation.condition_description : '-'))])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-239984e6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/modals/OperationInfo.vue
// module id = 532
// module chunks = 0